// src/data/copyDictionary.js
//
// ONE place for sport-vs-corporate UI copy (Phase 3 of docs/archive/ROLLOUT-CHECKLIST.md).
// Every entry is [sport, corporate]. Components read it through
// hooks/useOrgVoice.js (t(key)) — or copyFor(key, isCorporate) when a
// component is iterating several organizations.
//
// Persisted values are NOT copy and never change here: role: 'coach',
// org.coaches[], memberType tags ('athlete'), surface ids, route ids.

export const COPY = {
    // roles
    roleUser: ['Athlete', 'Employee'],
    roleUserLower: ['athlete', 'employee'],
    roleUserPlural: ['Athletes', 'Employees'],
    roleManager: ['Coach', 'Manager'],
    roleExec: ['System Admin', 'HR / Exec'],
    personaExec: ['Admin', 'Exec'],

    // sidebar groups + nav
    groupManager: ['Coach Views', 'Management Tools'],
    groupUser: ['Athlete Views', 'Employee Resources'],
    groupDaily: ['Daily Focus', 'My Workspace'],
    navDashboard: ['My Weekly Plan', 'My Workspace'],
    navMentalHealth: ['Mental Health', 'Mental Well-being'],
    navMentalPerformance: ['Mental Fitness', 'Cognitive Endurance'],
    navPerformance123: ['Performance 1-2-3', 'Daily Standup'],
    navFamilyHuddle: ['Family Huddle', 'Working Parents'],
    navKidz: ['Kidz Corner', 'Family Support'],
    navSquadPlaybook: ['Squad Playbook', 'Manager Toolkit'],
    navExecInsights: ['Executive Insights', 'Workforce Analytics'],
    navCcOverview: ['Overview', 'Executive Overview'],
    navCcReadiness: ['Readiness & Risk', 'Readiness & Strain'],
    navCcPredictive: ['Predictive Models', 'STD Claims Forecast'],

    // squad / manager dashboard
    squadTitle: ['Squad Dashboard', 'Manager Toolkit'],
    squadPreviewTitle: ['Previewing Squad Dashboard', 'Previewing Manager Toolkit'],
    memberLabelPlural: ['Active Athletes', 'Active Employees'],
    memberLabelSingle: ['athlete', 'employee'],
    squadNoData: ['No active squads are available to view. Admins must create groups in the Admin Portal.', 'No active teams are available to view. Admins must create groups in the Admin Portal.'],
    habitTitle: ['Player Habits (Visible to Team)', 'Employee Habits (Visible to Team)'],
    deployMsg: ['Deployed to Squad', 'Deployed to Team'],
    planTitle: ["Coach's Implementation Plan", "Manager's Implementation Plan"],
    planSubtitle: ['Tactical practice integration for', 'Tactical workflow integration for'],

    // org admin
    groupUnit: ['Squad', 'Team/Dept'],
    groupPlaceholder: ['e.g. Defense, U14 A...', 'e.g. Sales, Engineering...'],
    auditLog: ['Athlete Audit Log', 'Employee Audit Log'],

    // the admin's "View as a member" button
    viewAsSub: ['Player, parent, coach: each view, sample data', 'Employee, family, manager: each view, sample data'],

    // the team join link card on the manager dashboard (persisted role stays 'coach')
    joinLinkSub: ['Send this to your families. Anyone who joins from it lands on your team, with nothing to choose.', 'Send this to your people. Anyone who joins from it lands on your team, with nothing to choose.'],
    staffLinkTitle: ['Bench staff link', 'Manager link'],
    staffLinkSub: ['For your assistants, manager and other bench staff. Anyone who joins from it gets this team\'s coach view, so it goes to staff only.', 'For the supervisors and team leads who help you run this team. Anyone who joins from it gets this team\'s manager view, so it goes to leaders only.'],
    staffLinkCopy: ['Copy staff link', 'Copy manager link'],
    staffLinkShow: ['Show staff link', 'Show manager link'],
    staffLinkNone: ['No staff code is set for your organization yet. Ask your administrator.', 'No manager code is set for your organization yet. Ask your administrator.'],
    coachLinesHeading: ['Lines you can give a player', 'Lines you can give an employee'],

    // recharge hub
    rechargeInvite: ['give your body permission to come off the gas.', 'give yourself permission to step back from the workload for a few minutes.']
};

// Every non-sport industry reads the workplace column: a community hub or a
// police service has teams and departments, not squads and athletes.
export const isCorporateOrg = (org) => !!org?.industry && org.industry !== 'sport';

export const copyFor = (key, isCorporate) => {
    const pair = COPY[key];
    if (!pair) return key;
    return pair[isCorporate ? 1 : 0];
};
